export enum DebugSessionCreationReasonType {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
  ISSUE = 'ISSUE',
}
